// src/index.jsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './config/http'; // Registers the axios interceptor that sends the JWT on every API call
import { Provider } from 'react-redux'; // Import the Provider
import store from './redux/store'; // Import the Redux store
import './App.css'; // Corrected the import path (removed ../src/)
import { LocalizationProvider } from '@mui/x-date-pickers'; // Import LocalizationProvider
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; // Import AdapterDayjs

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Wrap your app with the Provider and pass the store */}
    <Provider store={store}>
      {/* Wrap your app with LocalizationProvider and pass the adapter */}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <App />
      </LocalizationProvider>
    </Provider>
  </React.StrictMode>
);
